module.exports = __webpack_public_path__ + "static/media/bonaire.5cbedced.svg";